module.exports = __webpack_public_path__ + "static/media/ic_hs_pay_freq.94debc61.svg";